import React, { useState, useCallback, useEffect, useContext } from "react";
import { useSession } from "next-auth/client";
import { toast } from "react-toastify";

import ReactFlow, {
  Controls,
  addEdge,
  Background,
  removeElements,
} from "react-flow-renderer";

import {
  postServerData,
  putServerData,
  delServerData,
  getServerData,
} from "actions";

import ConnectionLine from "./ConnectionLine";
import Ball from "./Ball";
import Container from "components/Container";
import { ChartContext } from "providers/chart";
const nodeTypes = {
  selectorNode: Ball,
};

function Chart({ data, lines }) {
  const [session] = useSession();
  const { editing, setAllLines } = useContext(ChartContext);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [elements, setElements] = useState([]);

  useEffect(() => {
    // const onChange = (event) => {
    //   setElements((els) =>
    //     els.map((e) => {
    //       return {
    //         ...e,
    //         data: {
    //           ...e.data,
    //         },
    //       };
    //     })
    //   );
    // };

    const newElem = data.map((dat) => ({
      id: String(dat.id),
      type: "selectorNode",
      data: {
        dat,
        theSizes: {
          width: dat.size,
          height: dat.size,
        },
        handles:
          dat.handles &&
          dat.handles.length > 0 &&
          dat.handles.map((h) => ({ ...h, id: String(h.id) })),
      },
      position: {
        x: dat.pos_x ? dat.pos_x : 250,
        y: dat.pos_y ? dat.pos_y : 5,
      },
    }));

    const newLines =
      lines && lines.length > 0
        ? lines.map((lin) => ({
            ...lin,
            id: String(lin.id),
          }))
        : [];

    setAllLines(newLines);

    setElements([...newElem, ...newLines]);
  }, [data, lines]);

  const onElementsRemove = useCallback(
    async (elementsToRemove) => {
      try {
        for (const el of elementsToRemove) {
          if (el.data && el.position) {
            await delServerData(`fontes/${el.id}`, session.accessToken);
          } else {
            await delServerData(`ligacoes/${el.id}`, session.accessToken);
          }
        }
        const countLines = await getServerData("ligacoes/count", session.accessToken);
    
        let getAllLines = [] 
        const size = 100
        const pages = countLines / size
    
        for( let actualPage = 0; actualPage <  pages; actualPage++){
          const getlines = await getServerData(`ligacoes?_start=${actualPage * size}`, session.accessToken);
          getAllLines = [...getAllLines, ...getlines]
        }
    
        const newLines =
          getAllLines && getAllLines.length > 0
            ? getAllLines.map((lin) => ({
                ...lin,
                id: String(lin.id),
              }))
            : [];

        setAllLines(newLines);

        setElements((els) => removeElements(elementsToRemove, els));
      } catch (error) {
        toast.error("Erro de conexão, tente mais tarde");
        console.log(error);
      }
    },
    [session, elements]
  );

  const onConnect = useCallback(
    async (params) => {
      if (
        elements.find(
          (e) =>
            e.sourceHandle === params.sourceHandle &&
            e.source === params.source &&
            e.target === params.target
        )
      ) {
        return;
      }
      try {

        await postServerData(
          "ligacoes",
          { ...params, type: "smoothstep" },
          session.accessToken
        );

        const countLines = await getServerData("ligacoes/count", session.accessToken);
    
        let getAllLines = [] 
        const size = 100
        const pages = countLines / size
    
        for( let actualPage = 0; actualPage <  pages; actualPage++){
          const getlines = await getServerData(`ligacoes?_start=${actualPage * size}`, session.accessToken);
          getAllLines = [...getAllLines, ...getlines]
        }
    
        const newLines =
          getAllLines && getAllLines.length > 0
            ? getAllLines.map((lin) => ({
                ...lin,
                id: String(lin.id),
              }))
            : [];

        setAllLines(newLines);

        setElements((els) => addEdge({ ...params, type: "smoothstep" }, els));
      } catch (error) {
        toast.error("Erro de conexão, tente mais tarde");
        console.log(error);
      }
    },
    [session, elements]
  );

  const handlePos = useCallback(
    async (e, node) => {
      try {
        await putServerData(
          `fontes/${node.id}`,
          { pos_x: node.position.x, pos_y: node.position.y },
          session.accessToken
        );
      } catch (error) {
        toast.error("Erro de conexão, tente mais tarde");
        console.log(error);
      }
    },
    [session]
  );

  const onLoad = (rf) => {
    setReactFlowInstance(rf);
  };

  useEffect(() => {
    if (reactFlowInstance && elements.length) {
      reactFlowInstance.fitView();
    }
  }, [reactFlowInstance, elements]);

  // const handleLoad = (instance) => {
  //   console.log("entrei na instancia");
  //   setTimeout(() => instance.fitView(), 0);
  // };

  return (
    <Container outClass="mapCont" innerClass="mapInner">
      <div className="box">
        <ReactFlow
          elements={elements}
          connectionLineComponent={ConnectionLine}
          onElementsRemove={onElementsRemove}
          onConnect={onConnect}
          nodeTypes={nodeTypes}
          snapToGrid={true}
          nodesConnectable={editing}
          nodesDraggable={editing}
          onNodeDragStop={handlePos}
          snapGrid={[1, 1]}
          onLoad={onLoad}
        >
          {/* <MiniMap /> */}
          <Controls />
          <Background />
        </ReactFlow>
      </div>
    </Container>
  );
}

export default Chart;
